module.exports = __webpack_public_path__ + "static/media/dm1.1d02f0fa.svg";